module.exports = __webpack_public_path__ + "img/analytic120 3.62107eb2.svg";